module.exports = __webpack_public_path__ + "img/hotel-11a.c480c2f5.jpeg";